const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.23254 0C5.6734 0 2.76976 2.87204 2.76976 6.39245C2.76976 8.59328 3.90537 10.5475 5.62631 11.7009C2.33306 13.0981 0 16.3309 0 20.0906H1.84651C1.84651 16.0451 5.14253 12.7849 9.23254 12.7849C11.2129 12.7849 12.9837 13.5876 14.3104 14.8396L9.95361 19.149L9.89636 19.434L9.26117 22.6594L8.97311 24L10.3294 23.7151L13.5885 23.0868L13.8774 23.0302L23.1968 13.8123C24.2677 12.7529 24.2677 10.9904 23.1968 9.93113C22.6799 9.42404 21.983 9.13717 21.255 9.13188C20.527 9.12658 19.8259 9.4033 19.3016 9.90282L15.6381 13.5273C14.8242 12.7563 13.8758 12.1375 12.8388 11.7009C13.7172 11.1144 14.437 10.3238 14.935 9.39831C15.4329 8.47288 15.694 7.44081 15.6953 6.39245C15.6953 2.87204 12.7917 0 9.23254 0ZM9.23254 1.82641C11.7927 1.82641 13.8488 3.86013 13.8488 6.39245C13.8488 8.92477 11.7927 10.9585 9.23254 10.9585C6.67236 10.9585 4.61627 8.92477 4.61627 6.39245C4.61627 3.86013 6.67236 1.82641 9.23254 1.82641ZM21.2349 10.9585C21.4694 10.9585 21.7149 11.0334 21.8987 11.2151C21.9858 11.2983 22.0552 11.398 22.1025 11.5083C22.1499 11.6186 22.1743 11.7373 22.1743 11.8571C22.1743 11.9769 22.1499 12.0955 22.1025 12.2058C22.0552 12.3161 21.9858 12.4159 21.8987 12.4991L12.9542 21.3462L11.3099 21.6887L11.6561 20.0622L20.6006 11.2151C20.683 11.1317 20.7817 11.0659 20.8908 11.0218C20.9999 10.9777 21.117 10.9561 21.2349 10.9585Z"
        fill="white"
      />
    </svg>
  );
};

export default EditIcon;
